import React from 'react';
import { upperFirst } from 'lodash';

import NotificationContent from '../../shared/AppointmentContainer';
import Header from './components/Header';
import Footer from '../../shared/Footer';
import Logo from '../../shared/Logo';
import ConfirmationCode from './components/ConfirmationCode';
import AppointmentInfo from '../../shared/AppointmentInfo';
import ShopLocation from '../../shared/ShopLocation';
import PhonesBackground from '../../shared/PhonesBackground';
import SquireInfo from '../../shared/SquireInfo';
import withAppointmentNotification from '../../hoc/withAppointmentNotification';
import BookCta from '../../shared/BookCta';

/* eslint-disable react/prop-types */
const CustomerCanceledAppointment = ({
  shop,
  date,
  customer,
  confirmationCode,
  barber,
  service,
  address,
  duration,
  reservationLink,
  appLink,
  squireInfoClassName,
}) => (
  <div>
    <Header date={date} shopName={shop.name} />
    <NotificationContent danger>
      <div className="u-flex u-justify-content-space-between u-align-center">
        <Logo />
        <ConfirmationCode className="u-hide-on-mobile--flex" code={confirmationCode} />
      </div>
      <h2 className="u-text-huge u-fw-bold u-mt-12 u-mb-10">
         Hey {upperFirst(customer.firstName)}, your appointment was canceled.
      </h2>
      <div className="u-text-extrasmall u-fw-bold u-tt-uppercase u-co-grey u-mb-4">
        Canceled appointment
      </div>
      <div className="u-flex u-justify-content-space-between u-flex-wrap">
        <AppointmentInfo
          cancel
          confirmationCode={confirmationCode}
          barberName={`${barber.firstName} ${(barber.lastName || '')[0]}.`}
          service={service}
          date={date}
          duration={duration}
        >
          <a className="c-book-again-button u-mt-8 u-text-medium" href={appLink} target="_blank">
            Book again
          </a>
        </AppointmentInfo>
        <div className="c-appointment-info-divider u-hide-on-desktop" />
        <ShopLocation
          shopName={shop.name}
          phone={shop.phone}
          line1={address.line1}
          line2={address.line2}
          map={shop.staticMap.url}
          directions={address.directions}
        />
      </div>
      { shop.mobileAppCta && <BookCta appLink={appLink} /> }
      { shop.mobileAppCta && <PhonesBackground name="rebook" /> }
      <div className={squireInfoClassName}>
        <SquireInfo
          standalone={!shop.mobileAppCta}
          reservationLink={reservationLink}
          shopName={shop.name}
          isCustomerEmail
        />
      </div>
    </NotificationContent>
    <Footer link={appLink} />
  </div>
);

export default withAppointmentNotification(CustomerCanceledAppointment);



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerCanceledAppointment/index.jsx